document.addEventListener('DOMContentLoaded', function() {

  const url = new URL(window.location.href);
  const postedType = ["customer_posted", "contact_posted"].find(key => url.searchParams.get(key) === "true");
    
  if (postedType) {
      
    const hash = url.hash.replace("#", "");
    let gaEvent = null;
    let fbContent = null;

    // Wholesale form
    if (hash === "wholesale_quote_form") {

      gaEvent = "adw_form_wholesale";
      fbContent = "Wholesale";

    }

    // Newsletter
    else if (postedType === "customer_posted") {

      gaEvent = "adw_form_newsletter";
      fbContent = "Newsletter";

    }

    // Contact
    else if (postedType === "contact_posted") {

      gaEvent = "adw_form_contact";
      fbContent = "Contacto";

    }

    if (typeof gtag === "function" && gaEvent) {
      gtag("event", gaEvent);
    }

    if (typeof fbq === "function" && fbContent) {
      fbq("track", "Lead", {
        content_name: fbContent
      });
    }

    console.log({
      postedType,
      hash,
      gaEvent,
      fbContent
    });

  }

  /*
  * APP: https://apps.shopify.com/whatsapp-sharing
  */
    window.spWhatsAppTrack = function(buttonType){
       if(buttonType == 'widgetButton'){
            if (typeof gtag == 'function') {
                gtag("event", "adw_click_whatsapp_chat");
            };
            if (typeof ga == 'function') {
                ga('send', 'event', 'telefono', 'click', 'whatsapp');
            };
            if (typeof fbq == 'function') {
                fbq('track', 'Contact', { content_name: 'whatsapp' });
            };
           console.log('click in whatsapp');
         
       }
    };

  // jQuery is not loaded
  console.log("without jquery load");

  /**
   * Activacion e incrustación de clases para eventos
   */
  document.querySelectorAll('a[href^="tel"]').forEach((element) => {
    element.classList.add("link-phone");
    element.addEventListener("click", function () {
      if (typeof gtag == "function") {
        gtag("event", "adw_click_phone");
      }
      if (typeof fbq == "function") {
        fbq("track", "Contact", { content_name: "telefono" });
      }
    });
  });
  document.querySelectorAll('a[href^="mailto"]').forEach((element) => {
    element.classList.add("link-email");
    element.setAttribute("target", "_blank");
    element.addEventListener("click", function () {
      if (typeof gtag == "function") {
        gtag("event", "adw_click_email");
      }
      if (typeof fbq == "function") {
        fbq("track", "Contact", { content_name: "email" });
      }
    });
  });
  document.querySelectorAll('a[href*="wa.me"]').forEach((element) => {
    element.classList.add("link-whatsapp");
    element.setAttribute("target", "_blank");
    element.addEventListener("click", function () {
      if (typeof gtag == "function") {
        gtag("event", "adw_click_whatsapp");
      }
      if (typeof fbq == "function") {
        fbq("track", "Contact", { content_name: "whatsapp" });
      }
    });
  });
  document.querySelectorAll('a[href*="api.whatsapp"]').forEach((element) => {
    element.classList.add("link-whatsapp");
    element.setAttribute("target", "_blank");
    element.addEventListener("click", function () {
      if (typeof gtag == "function") {
        gtag("event", "adw_click_whatsapp");
      }
      if (typeof fbq == "function") {
        fbq("track", "Contact", { content_name: "whatsapp" });
      }
    });
  });
  document.querySelectorAll('a[href*="m.me"]').forEach((element) => {
    element.classList.add("link-messenger");
    element.setAttribute("target", "_blank");
    element.addEventListener("click", function () {
      if (typeof gtag == "function") {
        gtag("event", "adw_click_messenger");
      }
      if (typeof fbq == "function") {
        fbq("track", "Contact", { content_name: "messenger" });
      }
    });
  });
  document.querySelectorAll('a[href*="maps.google"]').forEach((element) => {
    element.classList.add("link-map");
    element.setAttribute("target", "_blank");
    element.addEventListener("click", function () {
      if (typeof gtag == "function") {
        gtag("event", "adw_click_map");
      }
      if (typeof fbq == "function") {
        fbq("track", "Contact", { content_name: "maps" });
      }
    });
  });
})